import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleAuthService } from '../../services/googleAuthService';
import { store } from '../../redux/store';

const OAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Получаем state из URL для определения типа действия (login/register)
        const urlParams = new URLSearchParams(window.location.search);
        const state = urlParams.get('state');
        const isRegistration = state === 'register';

        // Проверяем Google OAuth callback (асинхронно)
        await googleAuthService.handleRedirectCallback();

        // Ждем сохранения токена и загрузки профиля
        // Проверяем токен несколько раз с интервалами для надежности
        let attempts = 0;
        const maxAttempts = 10;

        // Функция для проверки токена в store
        const checkToken = () => {
          const state = store.getState();
          return state?.auth?.token && state?.auth?.isLoggedIn;
        };

        // Ждем пока токен появится в Redux store
        while (!checkToken() && attempts < maxAttempts) {
          await new Promise((resolve) => setTimeout(resolve, 300));
          attempts++;
        }

        if (checkToken()) {
          // Очищаем URL от параметров OAuth перед редиректом
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );

          // Дополнительная небольшая задержка для обновления состояния
          await new Promise((resolve) => setTimeout(resolve, 200));

          // Перенаправляем на главную страницу
          navigate('/home', { replace: true });
        } else {
          // Если нет токена, проверяем, была ли это регистрация
          if (isRegistration) {
            // При регистрации редиректим обратно на регистрацию с сообщением
            navigate('/', { replace: true });
          } else {
            // При логине редиректим на логин
            navigate('/', { replace: true });
          }
        }
      } catch (error) {
        const urlParams = new URLSearchParams(window.location.search);
        const state = urlParams.get('state');
        const isRegistration = state === 'register';

        // Редиректим в зависимости от типа действия
        navigate(isRegistration ? '/' : '/', { replace: true });
      }
    };

    handleOAuthCallback();
  }, [navigate]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center' 
    }}>
      <div style={{
        width: '50px',
        height: '50px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #FF7601',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default OAuthCallback;

